import Vue from 'vue';

// routers 设定
import VueRouter from 'vue-router';
import fullscreenRouters from './fullscreen-router';
import menuRouters from './menu-router'; // 展示在菜单中的路由
import menuOtherRouters from './menu-other-router'; // 不展示在菜单中的详情页路由
import mainMenuRouter from './mainMenu'; // 不展示在菜单中的详情页路由

// vuex store
import store from '../store/index';

// 路由配置
Vue.use(VueRouter);

// 路由包括菜单路由和其它路由
let allMenus = menuRouters.concat(fullscreenRouters, menuOtherRouters);
allMenus.push(mainMenuRouter[0]);
const RouterConfig = {
    mode: 'history', // 去除路由中的# 
    routes: allMenus
};
const router = new VueRouter(RouterConfig);
// 页面长时间停留或发版后，懒加载资源可能失效，自动刷新一次进行自愈
const CHUNK_RELOAD_FLAG = '__chunk_reload_once__';
const CHUNK_RELOAD_TS_FLAG = '__chunk_reload_once_ts__';
const CHUNK_RELOAD_TTL = 60 * 1000;
function isChunkLoadError(err) {
    const msg = (err && (err.message || err.msg || '')).toString();
    return /Loading chunk [\d]+ failed/i.test(msg)
        || /ChunkLoadError/i.test(msg)
        || /CSS chunk load failed/i.test(msg);
}
// 路由前置操作
router.beforeEach((to, from, next) => {
    // store.commit('updateBreadCrumb', to);
    if (to.meta.current) {
        console.log('路由切换:', to.name, to.meta.current, to.meta.parent);
        store.commit('setCurMenuRouter', to.meta.current[0]);
        // store.commit('setCurMenuRouter',to.meta.parent);
        store.commit('setCurMenuOpened', to.meta.parent);
        console.log('设置菜单状态:', to.meta.current[0], to.meta.parent);
        // console.log(to.meta.current);
        // if(to.meta.current[0] == 'pileList'||to.meta.current[0] == 'custList'){
        //     console.log(store.state.pileObj);
        //     store.commit('setCustObj', null);
        //     store.commit('setPileObj', null);
        // }
        next();
    } else {
        next();
    }

});
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
router.onError((err) => {
    if (!isChunkLoadError(err)) return;
    const reloadTs = Number(sessionStorage.getItem(CHUNK_RELOAD_TS_FLAG) || 0);
    const hasReloaded = sessionStorage.getItem(CHUNK_RELOAD_FLAG) === '1'
        && Date.now() - reloadTs < CHUNK_RELOAD_TTL;
    if (!hasReloaded) {
        sessionStorage.setItem(CHUNK_RELOAD_FLAG, '1');
        sessionStorage.setItem(CHUNK_RELOAD_TS_FLAG, String(Date.now()));
        window.location.reload();
        return;
    }
    sessionStorage.removeItem(CHUNK_RELOAD_FLAG);
    sessionStorage.removeItem(CHUNK_RELOAD_TS_FLAG);
});
export default router;